import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminCallReport from "@/pages/admin/AdminCallReport";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/call-report")({
  head: () => adminHead("Call Tap Report", "Click-to-call breakdown report.", "/admin/call-report"),
  component: () => (
    <ProtectedRoute>
      <AdminCallReport />
    </ProtectedRoute>
  ),
});
